import {
  ActionButton,
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  Icon,
  Label,
  MessageBar,
  SelectionMode,
  Spinner,
  Stack,
} from '@fluentui/react';
import dateFormat from 'dateformat';
import { useEffect, useState } from 'react';

import { popup } from '../../../addons/Popup';
import { useAppSelector } from '../../../App/store';
import { getAsync } from '../../../utils/api';

type Invoice = {
  uuid: string;
  name: string;
  invoiceTime: number;
  systemCreated: boolean;
};

export default () => {
  const [invoices, setInvoices] = useState<Invoice[]>();
  const canProcessInvoices = useAppSelector(
    (state) => state.auth.userdata?.canProcessInvoices
  );

  useEffect(() => {
    if (!canProcessInvoices) return;

    getAsync("/invoices/fetch-latest")
      .then((res) => {
        if (res.success) {
          setInvoices(res.data);
        } else {
          popup("Hata oluştu");
        }
      })
      .catch(() => {
        popup({
          title: "Hata oluştu",
          message: (
            <>
              Hata oluştu. E-Finans şifresi hatalı olabilir, değiştirmek için{" "}
              <a
                href="https://cdn.eaksy.com/media/xfQsf7qa2D.mp4"
                target={"_blank"}
              >
                https://cdn.eaksy.com/media/xfQsf7qa2D.mp4
              </a>
            </>
          ) as any as string,
        });
      });
  }, [canProcessInvoices]);

  if (!canProcessInvoices) {
    return <MessageBar>Fatura entegrasyonu bulunmuyor</MessageBar>;
  } else if (!invoices) {
    return <Spinner style={{ height: "80vh" }} />;
  } else {
    return (
      <DetailsList
        items={invoices}
        columns={columns}
        selectionMode={SelectionMode.none}
        layoutMode={DetailsListLayoutMode.fixedColumns}
        styles={{ root: { overflow: "hidden" } }}
      />
    );
  }
};

const invoiceButtons = (item: Invoice) => {
  const [isLoading, setIsLoading] = useState(false);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Stack horizontal tokens={{ childrenGap: 10 }}>
      <ActionButton
        iconProps={{ iconName: "Page" }}
        text={
          (
            <>
              Fatura <Icon iconName="NavigateExternalInline" />
            </>
          ) as any as string
        }
        onClick={() =>
          window.open(
            `https://earsiv.efinans.com.tr/earsiv/goruntule.jsp?vkn=6310084958&email=1&uuid=${item.uuid}`,
            "_blank"
          )
        }
      />
      <ActionButton
        iconProps={{ iconName: "Folder" }}
        text="Form"
        onClick={async () => {
          setIsLoading(true);

          const { formId } = await getAsync(
            "/forms/get-id-by-invoice-uuid?uuid=" + item.uuid
          );
          const pdf = await getAsync(
            "/forms/get-pdf?id=" + encodeURIComponent(formId)
          );
          const url = URL.createObjectURL(pdf);

          setIsLoading(false);
          window.open(url);
        }}
      />
    </Stack>
  );
};
const columns: IColumn[] = [
  {
    key: "index",
    name: "#",
    iconName: "NumberSymbol",
    isIconOnly: true,
    minWidth: 16,
    maxWidth: 16,
    onRender: (_, index) => (
      <Label>{index !== undefined ? index + 1 : ""}</Label>
    ),
  },
  {
    key: "name",
    name: "Alıcı",
    minWidth: 50,
    flexGrow: 2,
    onRender: (item: Invoice) => item.name,
  },
  {
    key: "channel",
    name: "Kanal",
    minWidth: 50,
    flexGrow: 1,
    onRender: (item: Invoice) => (item.systemCreated ? "Sistem" : "Diğer"),
  },
  {
    key: "time",
    name: "Fatura Tarihi",
    minWidth: 50,
    flexGrow: 1.5,
    onRender: (item: Invoice) =>
      dateFormat(new Date(item.invoiceTime), "dd.mm.yyyy HH:mm"),
  },
  {
    key: "view",
    name: "Görüntüle",
    minWidth: 150,
    flexGrow: 1,
    onRender: invoiceButtons,
  },
];
